<template>
  <div :class="['background',auto == true ? 'background-auto' : 'background-fixed']">
    <!-- 登录页 -->
    <video v-if="$route.name === 'SignIn'" autoplay loop muted :src="videoURL"></video>
    <div class="background-mask" v-if="!auto">
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Background",
  props:{
    auto:{type:Boolean,default:true}
  },
  data() {
    return {
      // common - background video
      videoURL: require("@/assets/Background/background.mp4"),
      // common - background image
      imageURLs: [
        // { url: require("@/assets/Background/background-1.png") },
        { url: require("@/assets/Background/background-2.png") }
        // { url: require("@/assets/Background/background-3.png") }
      ],
      swiperOption: {
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        },
        effect: "fade",
        spaceBetween: 30
      }
    };
  }
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";
.background-fixed{
  position: fixed;
  top: 0;
  z-index: 0;
  // background-color: rgba($color: #003264, $alpha: 0.8);
  /*background:linear-gradient(180deg,rgba(0,0,0,0.3) 0%,rgba(0,0,0,0.02) 100%);*/
}
.background-auto{
  // margin-top: -$nav-height;
}
.background {
  width: 100vw;
  height: 100vh;
  > video {
    min-width: 100%;
    min-height: 100%;
  }
  &-Tourist{
    width: 100%;
    height: 100%;
    position: relative;
    img{
      width: 100%;
    }
    div{
      width: 100vw;
      position: absolute;
      top: 100vh;
      height: 100vh;
      background-image: -webkit-gradient(
          linear,
          left top,
          left bottom,
          from(rgba(255, 255, 255, 0.8)),
          color-stop(40%, rgba(255, 255, 255, 1))
        );
    }
  }
  &-student {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      filter: brightness(0.4) blur(20px);
    }
  }
  &-mask{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    /*opacity: .7;*/
    > div{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
    }
    > div:nth-child(1){
      /*background-color: rgba($color: $color-primary, $alpha: 1.0);*/
    }
    > div:nth-child(2){
      /*background-color: rgba($color: #000, $alpha: .6);*/
    }
  }
  > .swiper-container {
    width: 100%;
    height: 100%;
    .swiper-slide {
      overflow: hidden;
      img {
        min-width: 120%;
        height: 120%;
        filter: blur(10px);
        margin: -10px;
      }
    }
  }
}
</style>
